import { render, staticRenderFns } from "./sns.vue?vue&type=template&id=f4ed385e&scoped=true&"
import script from "./sns.vue?vue&type=script&lang=js&"
export * from "./sns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ed385e",
  null
  
)

export default component.exports